import { FilterType as FilterOperator } from "types/enums";

/**
 * Every operator a lead-data field rule offers, regardless of the field type.
 * Note: BE compares `< <= > >= between` as `(float)`, so for dates ("2024-05-01" → 2024.0) only the year counts.
 */
export const FIELD_OPERATORS: readonly FilterOperator[] = [
    FilterOperator.Equals,
    FilterOperator.NotEquals,
    FilterOperator.Contains,
    FilterOperator.NotContains,
    FilterOperator.StartsWith,
    FilterOperator.EndsWith,
    FilterOperator.IsLessThan,
    FilterOperator.IsLessThanOrEquals,
    FilterOperator.IsGreaterThan,
    FilterOperator.IsGreaterThanOrEquals,
    FilterOperator.IsBetween,
    FilterOperator.IsBetweenEquals,
    FilterOperator.RegexMatch,
    FilterOperator.RegexNotMatch,
    FilterOperator.IsTrue,
    FilterOperator.IsFalse,
    FilterOperator.IsEmpty,
    FilterOperator.IsNotEmpty,
];

/** Operators compared as numbers on BE (`(float)` cast). */
export const NUMERIC_OPERATORS: readonly FilterOperator[] = [
    FilterOperator.IsLessThan,
    FilterOperator.IsLessThanOrEquals,
    FilterOperator.IsGreaterThan,
    FilterOperator.IsGreaterThanOrEquals,
];

export const REGEX_OPERATORS: readonly FilterOperator[] = [FilterOperator.RegexMatch, FilterOperator.RegexNotMatch];
